import type { MapRegion } from '../map-style.ts';

/**
 * Has the operator moved the camera away from where the screen put it?
 *
 * `baseline` is the region the engine settled on after the screen's own
 * focus; `region` is the one it has settled on now. Away means the centre
 * moved by more than a fifth of the baseline's span, or the zoom changed by
 * more than 1.6× either way — a nudge to read a label is not a wander, and a
 * wander is what the raise panel's camera comes back from on its own.
 */
export function wanderedFrom(baseline: MapRegion, region: MapRegion): boolean {
  const span = (r: MapRegion) =>
    Math.max(r.maxLatitude - r.minLatitude, r.maxLongitude - r.minLongitude);
  const centre = (r: MapRegion) => ({
    lat: (r.minLatitude + r.maxLatitude) / 2,
    lon: (r.minLongitude + r.maxLongitude) / 2,
  });
  const bs = span(baseline);
  if (bs <= 0) return false;
  const zoomed = span(region) / bs;
  const moved =
    Math.abs(centre(region).lat - centre(baseline).lat) > bs * 0.2 ||
    Math.abs(centre(region).lon - centre(baseline).lon) > bs * 0.2;
  return moved || zoomed >= 1.6 || zoomed <= 1 / 1.6;
}
